import { render, staticRenderFns } from "./CampaignDrawer.vue?vue&type=template&id=58c9fd2d&scoped=true"
import script from "./CampaignDrawer.vue?vue&type=script&lang=js"
export * from "./CampaignDrawer.vue?vue&type=script&lang=js"
import style0 from "./CampaignDrawer.vue?vue&type=style&index=0&id=58c9fd2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9fd2d",
  null
  
)

export default component.exports